import { createTheme } from "@mui/material"

const theme = createTheme({
  palette: {
    primary: {
      main: "#049CE4",
    },
    text: {
      primary: "#011034",
    },
  },
})

export default theme
